module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Services"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "example-problem-group"
  }, [_c('div', {
    staticClass: "max_width",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-size": "24px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('Icon', {
    attrs: {
      "type": "chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    staticClass: "Product-search-input",
    attrs: {
      "placeholder": _vm.$t('enter_keyword')
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchFaq($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "Product-search-icon",
    attrs: {
      "src": require("../../assets/search_icon.png"),
      "width": "24"
    },
    on: {
      "click": _vm.searchFaq
    }
  })])]), _vm._v(" "), (_vm.null_problem_list_show) ? _c('div', {
    staticClass: "example-problem"
  }, [_c('div', {
    staticClass: "example-problem-main"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "10%",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact_us')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t('faq_service')))]), _vm._v(" "), _vm._l((_vm.contace_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "contact_way pcShow"
    }, [_c('div', {
      staticClass: "contact_item1"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "width": "40"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "contact_item2"
    }, [_c('p', [_vm._v(_vm._s(item.contact_tile) + ":")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "contact_item3"
    }, [_c('p', [_vm._v(_vm._s(item.contact_phone))])])])
  }), _vm._v(" "), _vm._l((_vm.contace_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "contact_way mobileShow"
    }, [_c('div', {
      staticClass: "contact_item1"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "width": "40"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "contact_item2"
    }, [_c('p', [_vm._v(_vm._s(item.contact_tile) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.contact_phone))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]) : _vm._l((_vm.problem_list), function(item, index, key) {
    return _c('div', {
      key: index,
      staticClass: "example-problem"
    }, [_c('div', {
      staticClass: "example-problem-main"
    }, [_c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "remain",
      attrs: {
        "to": {
          name: 'problemContent',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('Services_mainpage_remain_to_be_solved')) + "\n                    "), _c('Icon', {
      attrs: {
        "type": "chevron-right"
      }
    })], 1)], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "pages",
    staticStyle: {
      "margin": "10px",
      "padding-left": "4%"
    }
  }, [_c('page', {
    attrs: {
      "total": _vm.total,
      "length": _vm.limit
    },
    on: {
      "on-change": _vm.refreshData
    }
  })], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12e0f241","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/ProblemSearch.vue
// module id = 783
// module chunks = 0